module.exports = __webpack_public_path__ + "img/combination_drawings@2x.341d326.jpg";